import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import fetch from 'features/common/fetch';
import {
	applyTemplate,
	fetchCampaignTemplates,
	removeTemplate,
} from 'features/views/campaignSettings/templates/actions';
import { getTemplateTable } from 'features/views/campaignSettings/templates/selectors';

import TemplateTableRow from './TemplateTableRow';

export const TemplateTable = ({ campaignId, selectable, onSuccess }) => {
	const dispatch = useDispatch();

	const list = useSelector(getTemplateTable);

	useEffect(() => {
		dispatch(fetchCampaignTemplates());
	}, [dispatch]);

	const handleDelete = useCallback(
		(id) => {
			dispatch(removeTemplate(Number(id)));
		},
		[dispatch],
	);

	const handleSelect = useCallback(
		(templateId) => {
			dispatch(applyTemplate(templateId, campaignId, onSuccess));
		},
		[dispatch, campaignId, onSuccess],
	);

	const hasRecords = !isEmpty(list);

	return (
		<Stack spacing={3}>
			<SectionHeader text={getLabelMessage('templates:templateTable')} />
			<ComponentLoader fetchStorePath={fetch.constants.urls.campaignPatternList}>
				<ComponentLoader fetchStorePath={fetch.constants.urls.campaignPatternDelete} ignoreErrors>
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>{getLabelMessage('templates:templateName')}</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{!hasRecords ? (
								<TableHasNoResults />
							) : (
								list.map((template) => (
									<TableRow key={template.id}>
										<TableCell style={{ padding: 0 }}>
											<TemplateTableRow
												key={template.id}
												id={template.id}
												name={template.name}
												onDelete={handleDelete}
												onSelect={selectable ? handleSelect : null}
												selectable={selectable}
											/>
										</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				</ComponentLoader>
			</ComponentLoader>
		</Stack>
	);
};

TemplateTable.propTypes = {
	campaignId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	onSuccess: PropTypes.func,
	selectable: PropTypes.bool,
};

export default TemplateTable;
